export default __webpack_public_path__ + "static/5-092e283bea2fc47364b3b4db191826a1.jpeg";